export enum BetSlipInteractionTypeEnum {
	Submit = "Submit Bet Slip",
	OneClickBet = "One Click Bet",
	Reuse = "Reuse",
	Cashout = "CashOut",
	ConfirmCancel = "Confirm Cancel Slip",
	Share = "Bet Slip Share",
	ChatBetSlipShare = "Chat Bet Slip Share",
}
